import React from 'react';

/**
 * InstallPrompt — DISABILITATO.
 *
 * L'installazione PWA è gestita dal prompt nativo di Chrome,
 * che appare automaticamente SOLO sulla pagina /qr-login.
 * Su tutte le altre pagine il prompt è bloccato da index.tsx.
 *
 * Non serve più questo componente — Chrome gestisce tutto da solo.
 */
const InstallPrompt: React.FC = () => {
  return null;
};

export default InstallPrompt;
